import axios from 'axios';
const API_URL = "http://192.168.0.55:8080/integrador/";
export const api = axios.create({
    baseURL: API_URL,
});
export default api;
